import type { CSSProperties } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { HolidayInclusion } from "@/types";

const HOLIDAY_OPTIONS: HolidayInclusion[] = ["Inclure", "Exclure", "Seulement"];

type HolidayInclusionSelectProps = {
    value?: HolidayInclusion;
    onChange: (value: HolidayInclusion) => void;
    triggerClassName?: string;
    triggerStyle?: CSSProperties;
    placeholder?: string;
};

const HolidayInclusionSelect = ({
    value,
    onChange,
    triggerClassName,
    triggerStyle,
    placeholder = "Fériés",
}: HolidayInclusionSelectProps) => {
    return (
        <Select value={value} onValueChange={(val: string) => onChange(val as HolidayInclusion)}>
            <SelectTrigger className={triggerClassName} style={triggerStyle}>
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
                {HOLIDAY_OPTIONS.map((opt) => (
                    <SelectItem key={opt} value={opt}>{opt}</SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default HolidayInclusionSelect;
